import './SocieteGeneralisation.scss';

import { ArrowForward } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SaveIcon from '@mui/icons-material/Save';
import { Alert, Button, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import FelicitationIcon from '../../../../src/Assets/FelicitationIcon.png';
import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import { IconTextField, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import CountrySelect from '../../../Components/shared/SearchCountry';
import { API_SERVER_FILES } from '../../../config';
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
// import useFormValidation from '../../../hooks/useFormValidation';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import DocumentUpload from '../../../Utils/fileUpload/DocumentUpload';
import { CompareTwoString, isHttpStatusSuccess, isUrlFromCompleterProfile, SpliUrl } from '../../../Utils/utils';
import { typeTraitementEnum } from '../CompleterProfile/DonneesPersonnelsExpert';

function SocieteGeneralisation({ typeTraitement }) {

    SocieteGeneralisation.propTypes = {
        typeTraitement: PropTypes.any,
    };
    const { expertToBeCreated, setExpertToBeCreated } = useCraRdv();
    const { postData, postDataSilently } = usePostRequest();
    const { setBackdropOpen } = useUtilities();
    const { auth, setAuth } = useAuth();
    const location = useLocation();
    const role = useRole();
    const navigate = useNavigate();
    let param = useParams();
    const [nomEntreprise, setNomEntreprise] = useState('');
    const [address, setAddress] = useState('');
    const [localisation, setCountry] = useState();
    const [noImmatriculation, setNumImmatriculation] = useState('');
    const [noTVA, setNoTVA] = useState('');
    const [codePostal, setCodePostal] = useState('');
    const [nomBanque, setNomBanque] = useState('');
    const [IBAN, setIban] = useState('');
    const [BICSWIFT, setBicSwift] = useState('');
    const [tauxTva, setTauxTva] = useState('');
    //cette variable est réservée pour stocker le rib modifié par l'utilisateur
    const [Rib, setRib] = useState('');
    //first rib recuperé from backned avec la possibilité de visualisation
    const [ribFromBackend, setRibFromBackend] = useState('');
    const axiosPrivate = useAxiosPrivate();
    const [dataExpert, setDataExpert] = useState();
    const [firstDataFromBackend, setFirstDataFromBackend] = useState();
    const [CheckUpdateValue, setCheckUpdateValue] = useState(true);
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const target = useRef(null);
    // * required field declaration
    // const [isValid] = useFormValidation([
    //     { name: 'nomEntreprise', value: nomEntreprise },
    //     { name: 'address', value: address },
    //     { name: 'localisation', value: localisation },
    //     { name: 'noImmatriculation', value: noImmatriculation },
    //     { name: 'noTVA', value: noTVA },
    // ]);
    const currentPath = location?.pathname.split('/').pop();
    // const [messageAlert, setMessageAlert] = useState('');

    useEffect(() => {
        searchInfoExpert();
    }, [role]);

    useEffect(() => {
        if (dataExpert) {
            setFirstDataFromBackend(dataExpert);
            // setRibFromBackend(dataExpert?.entreprise?.RibUrl);
            initializeSocieteData(dataExpert?.entreprise);
        }
    }, [dataExpert]);

    useEffect(function () {
        // the handler for actually showing the prompt
        // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
        var handler = function (event) {
            event.preventDefault();
            event.returnValue = '';
        };
        if (CheckUpdateValue == false) {
            window.addEventListener('beforeunload', handler);
            // clean it up, if the dirty state changes
            return function () {
                window.removeEventListener('beforeunload', handler);
            };
        }
        // since this is not dirty, don't do anything
        return function () { };
    }, [CheckUpdateValue]);

    const searchInfoExpert = async () => {
        if (typeTraitement == typeTraitementEnum.EXPERT_UPDATE || typeTraitement == typeTraitementEnum.EXPERT_COMPLETE_PROFILE) {
            setBackdropOpen(true);
            try {
                const response = await axiosPrivate.get('expert/getMyInfos');
                setDataExpert(response?.data?.expert);
                console.log('data', response?.data?.expert?.entreprise);
            } catch (error) {
                console.log(error);
            }
            setBackdropOpen(false);
        }
        if (typeTraitement == typeTraitementEnum.READ_ONLY || typeTraitement == typeTraitementEnum.ADMIN_UPDATE_EXPERT) {
            setBackdropOpen(true);
            try {
                const response = await axiosPrivate.get('/users/getExpertById/' + param.ExpertId);
                setDataExpert(response?.data);
            } catch (error) {
                console.log(error);
            }
            setBackdropOpen(false);
        }
    };

    const navigateToNextStep = () => {
        if (isUrlFromCompleterProfile(location?.pathname)) {
            setBackdropOpen(false);
            Swal.fire({
                title: i18n.t('Félicitation!'),
                imageUrl: FelicitationIcon,
                text: i18n.t('Votre profil a été complété avec succès'),
                confirmButtonText: i18n.t('page d\'accueil'),
                confirmButtonColor: '#5CC889',
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    if (auth.completeStep < 5) {
                        // * Update the complete step to 5
                        setAuth({ ...auth, completeStep: 5 });
                    }
                    navigate('/expert', {});
                }
            });
        }
    };

    async function executeRequests(requestsToExecute) {
        const requestKeysInOrder = ['AddExpertStep1', 'AddExpertStep2_ResumeUpload', 'AddExpertStep2', 'AddExpertStep3', 'AddExpertStep4'];
        let expertId;
        for (const key of requestKeysInOrder) {
            const request = requestsToExecute[key];
            const { url, payload } = request;
            console.log('from executeRequests', key, request);
            if (url && payload) {
                // the formData payload was a function that takes in input an expertId, but now I change this sol
                if (typeof payload === 'function' || payload instanceof FormData) {
                    // add expertId to FormData
                    if(expertId){
                        payload.append('expertId', expertId);
                        try {
                            const response = await postDataSilently({ url, payload });
                            // if the payload is a function, it's the AddExpertStep2_ResumeUpload request
                            // const formData = new FormData();
                            // formData.append('file', payload());
                            // formData.append('expertId', expertId);
                            // console.log('hola', url, payload);
                            // const response = await postData({url, formData});
                            console.log(response);
                        // expertId = response.expertId;
                        } catch (error) {
                            console.log(error);
                            break;
                        }
                    }
                } else {
                    // for all other requests, add the expertId to the payload and send the request
                    payload.expertId = expertId;// { ...payload, expertId }
                    console.log('hola', url, payload);
                    try {
                        // expertId = response.expertId;
                        if (key === 'AddExpertStep1') {
                            const response = await postData({ url, payload });
                            expertId = response.data?.expert?._id;
                            console.log('ExpertID set', expertId);
                        }
                        // * the rest of the request which doesn't has formData
                        else await postDataSilently({ url, payload });
                    } catch (error) {
                        console.log(error);
                        break;
                    }
                }
            }
        }

        /*here is the object requests: {AddExpertStep1
        :
        {url: '/expert/completePersoData', payload: {…}}
        AddExpertStep2
        :
        {url: '/expert/storeCVData', payload: {…}}
        AddExpertStep2_ResumeUpload
        :
        expertId => {…}
        AddExpertStep3
        :
        {url: '/expert/completePreference', payload: {…}}
        AddExpertStep4
        :
        {url: '/expert/completeSociete', payload: FormData}},  I want a way to call them by this order :
        AddExpertStep1, AddExpertStep2_ResumeUpload,AddExpertStep2,AddExpertStep3,  AddExpertStep4 */
        // *
        // let expertId;

        // for (const [key, value] of Object.entries(requestsToExecute)) {
        //     let payload = value.payload;
        //     // check if payload is defined before modifying it
        //     if (payload && expertId) {
        //         if (payload instanceof FormData) {
        //             // add expertId to FormData
        //             payload.append('expertId', expertId);
        //         } else {
        //             // add expertId to simple object
        //             payload.expertId = expertId;
        //         }
        //     } else {
        //         // handle the case where payload is undefined
        //         console.log('Payload is undefined', payload);
        //     }
        //     console.log('from executeRequests', key, value, value.url, payload);

        //     const response = await postData(value.url, payload);

        //     if (key === 'AddExpertStep1') {
        //         expertId = response.expertId;
        //     }
        // }
    }
    // * v1, expertData is not dynamique, so it is not working at all
    // async function executeRequests(requests) {
    //     let responseData;
    //     for (const requestName in requests) {
    //         const request = requests[requestName];
    //         const response = await postData(request);
    //         if (response) {
    //             responseData = response;
    //             console.log(`Response for ${requestName}: ${JSON.stringify(response)}`);
    //         } else {
    //             console.log(`Error for ${requestName}`);
    //             return;
    //         }
    //     }
    //     return responseData;
    // }
    const handleSubmit = async () => {
        // if (Rib || nomEntreprise || address || localisation || noImmatriculation || noTVA || nomBanque || IBAN || BICSWIFT) {
        const formData = new FormData();
        try {
            nomEntreprise && formData.append('nom', nomEntreprise);
            address && formData.append('address', address);
            localisation && formData.append('localisation', localisation);
            noImmatriculation && formData.append('noImmatriculation', noImmatriculation);
            codePostal && formData.append('codePostal', codePostal);
            noTVA && formData.append('noTVA', noTVA);
            tauxTva && formData.append('tauxTva', tauxTva);
            if (typeTraitement != typeTraitementEnum.EXPERT_COMPLETE_PROFILE && !isUrlFromCompleterProfile(location?.pathname)) {
                // if(Rib instanceof File){
                //     formData.append('rib', Rib);
                // }
                Rib && formData.append('rib', Rib);
                nomBanque && formData.append('nomBanque', nomBanque);
                IBAN && formData.append('IBAN', IBAN);
                BICSWIFT && formData.append('BICSWIFT', BICSWIFT);
            }

            // if (typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT) // ! on pass plus l expert id inside of state
            //     formData.append('expertId', location?.state?.expertId);
            // since admin now can modify tauxTva ANytime
            if (typeTraitement == typeTraitementEnum.ADMIN_UPDATE_EXPERT || typeTraitement == typeTraitementEnum.READ_ONLY)
                formData.append('expertId', param?.ExpertId);

            formData.append('isFromAccountCompletion', isUrlFromCompleterProfile(location?.pathname));
            let response1;
            if (typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT) {
                // location?.state?.requestsToExecute: {AddExpertStep1, AddExpertStep2_ResumeUpload,AddExpertStep2,AddExpertStep3,
                // AddExpertStep4: { url: '/expert/completeSociete', payload: formData,  } }
                (async () => {
                    try {
                        const response = await executeRequests({ ...expertToBeCreated, AddExpertStep4: { url: '/expert/completeSociete', payload: formData } });
                        setExpertToBeCreated(null);
                        navigate('/admin/gestionExperts', { replace: true });
                        console.log('Final response:', response);
                    } catch (error) {
                        console.log(error);
                    }
                })();
            }
            else {
                response1 = await postData({
                    url: '/expert/completeSociete',
                    payload: formData,
                });
                const response = await response1.data;
                console.log('submitresumeBackend', response);
                if (isHttpStatusSuccess(response1.responseStatus)) {
                    setFirstDataFromBackend(response?.expert);
                    setDataExpert(response?.expert);
                    // *OLD async with backend :
                    // if(typeTraitement==typeTraitementEnum.ADMIN_ADD_EXPERT){
                    //     navigate('/admin/gestionExperts', { replace: true });
                    // }
                    setCheckUpdateValue(true);
                    navigateToNextStep();
                }
            }
        } catch (error) {
            console.log(error.response?.status);
        }
        // }
        // else {
        //     console.log('no videe');
        //     if (isUrlFromCompleterProfile(location?.pathname))
        //         setMessageAlert('Veuillez remplir les champs avant de cliquer sur suivant');
        // }
    };

    const initializeSocieteData = (savedEntrepriseData) => {
        setRib(savedEntrepriseData?.RibUrl);
        setRibFromBackend(dataExpert?.entreprise?.RibUrl);
        setBicSwift(savedEntrepriseData?.BICSWIFT);
        setIban(firstDataFromBackend?.entreprise?.IBAN);
        setNomBanque(firstDataFromBackend?.entreprise?.nomBanque);
        setNoTVA(firstDataFromBackend?.entreprise?.noTVA);
        setNumImmatriculation(firstDataFromBackend?.entreprise?.noImmatriculation);
        setCodePostal(firstDataFromBackend?.entreprise?.codePostal);
        setAddress(firstDataFromBackend?.entreprise?.address);
        setCountry(firstDataFromBackend?.entreprise?.localisation);
        setNomEntreprise(firstDataFromBackend?.entreprise?.nom);
        setTauxTva(firstDataFromBackend?.entreprise?.tauxTva);

        setCheckUpdateValue(true);
    };

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    return (
        <form className='wholeprefstyle'>
            <h4 className='titlesociete'>{i18n.t('Société')}</h4>
            <div className='firstdivsociete'>
                {/* {messageAlert && (<div><Alert severity="error">{messageAlert}</Alert></div>)} */}
                <div className='divnomsociete'>
                    <p className='nomsocietetxt'>{i18n.t('Nom d\'entreprise')}</p>
                    <TextFieldComponent
                        value={nomEntreprise}
                        name='nomEntreprise'
                        disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                        onChange={(e) => {
                            if (!CompareTwoString(e.target.value, nomEntreprise))
                                setCheckUpdateValue(false);
                            setNomEntreprise(e.target.value);
                        }}
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                    />
                    {/*<input
                        type="text"
                        style={nomsocieteinput}
                    />*/}
                </div>
                <div className='divnomsociete'>
                    <b className='nomsocietetxt'>{i18n.t('Adresse du siège social')}</b>
                    <TextFieldComponent
                        value={address}
                        name='address'
                        disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                        onChange={(e) => {
                            if (!CompareTwoString(e.target.value, address))
                                setCheckUpdateValue(false);
                            setAddress(e.target.value);
                        }}
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ width: '100%', background: 'white', borderRadius: '8px' }}

                    />
                </div>
                <div className='tvaimmatruculation'>
                    <CountrySelect
                        width={device=='desktop'?'50%':'100%'}
                        country={localisation}
                        name='localisation'
                        label={i18n.t('Pays')}
                        setCountry={setCountry}
                        mode={typeTraitement}
                        setCheckUpdateValue={setCheckUpdateValue}
                    // style={{ width: '370px', background: 'white', borderRadius: '8px' }}
                    />
                    <TextFieldComponent
                        id="outlined-uncontrolled"
                        name='codePostal'
                        label={i18n.t('Code Postal')}
                        sx={{
                            '& > :not(style)': {borderRadius: '8px'},
                        }}
                        type='number'
                        onKeyDown={handleKeyDown}
                        InputProps={{
                            inputProps: { min: 0,}
                        }}
                        value={codePostal}
                        style={{width:device=='desktop'?'50%':'100%', background: 'white',borderRadius: '8px'}}
                        disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                        onChange={(e) => {
                            if(!CompareTwoString(e.target.value, codePostal)){
                                setCheckUpdateValue(false);
                            }
                            setCodePostal(e.target.value);
                        }}
                    />
                </div>
                <div className='tvaimmatruculation'>
                    <TextFieldComponent
                        label={i18n.t('Numéro d\'immatriculation')}
                        value={noImmatriculation}
                        name='noImmatriculation'
                        onChange={(e) => {
                            if (!CompareTwoString(e.target.value, noImmatriculation))
                                setCheckUpdateValue(false);
                            setNumImmatriculation(e.target.value);
                        }}
                        disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                    />
                </div>
                <div className='tvaimmatruculation'>
                    <TextFieldComponent
                        label={i18n.t('Numéro TVA')}
                        value={noTVA}
                        name='noTVA'
                        onChange={(e) => {
                            if (!CompareTwoString(e.target.value, noTVA))
                                setCheckUpdateValue(false);
                            setNoTVA(e.target.value);
                        }}
                        disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ width:(isUrlFromCompleterProfile(location?.pathname) || device!='desktop' ) ? '100%' :'50%', background: 'white', borderRadius: '8px' }}
                    />
                    {!isUrlFromCompleterProfile(location?.pathname) &&
                        <IconTextField
                            id="outlined-name"
                            label={i18n.t('Taux de la TVA')}
                            value={tauxTva}
                            iconStart={'%'}
                            InputProps={{
                                inputProps: { min: 0, max: 100 },
                                //startAdornment:
                                //(<div className='iconStyleStartAdornment'><InputAdornment position="start">
                                //    %
                                //</InputAdornment></div>),

                            }}
                            type='number'
                            onKeyDown={handleKeyDown}
                            onChange={(event) => {
                                if (!CompareTwoString(event.target.value, tauxTva)) {
                                    setCheckUpdateValue(false);
                                }
                                setTauxTva(event.target.value);
                            }}
                            disabled={role == 'expert'}
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            style={{ width: device=='desktop' ?'50%':'100%', background: 'white', borderRadius: '8px' }}
                        />
                    }
                </div>
            </div>
            {(typeTraitement != typeTraitementEnum.EXPERT_COMPLETE_PROFILE && !isUrlFromCompleterProfile(location?.pathname)) &&
                <>
                    <h4 className='titlesociete'>{i18n.t('Coordonnées bancaires')}</h4>
                    <div className='lastdivstyle'>
                        <div className='ribstyle'>
                            <b className='ribtxt'>{i18n.t('Nom de la banque')}</b>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                value={nomBanque}
                                disabled={typeTraitement == typeTraitementEnum.READ_ONLY}
                                onChange={(e) => {
                                    if (!CompareTwoString(e.target.value, nomBanque))
                                        setCheckUpdateValue(false);
                                    setNomBanque(e.target.value);
                                }}
                                style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                            />
                        </div>
                        <div className='ribstyle'>
                            <b className='ribtxt'>IBAN</b>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                disabled={typeTraitement == typeTraitementEnum.READ_ONLY}
                                value={IBAN}
                                onChange={(e) => {
                                    if (!CompareTwoString(e.target.value, IBAN))
                                        setCheckUpdateValue(false);
                                    setIban(e.target.value);
                                }}
                                style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                            />
                        </div>
                        <div className='ribstyle'>
                            <b className='ribtxt'>BIC/SWIFT</b>
                            <TextFieldComponent
                                value={BICSWIFT}
                                disabled={typeTraitement == typeTraitementEnum.READ_ONLY}
                                onChange={(e) => {
                                    if (!CompareTwoString(e.target.value, BICSWIFT))
                                        setCheckUpdateValue(false);
                                    setBicSwift(e.target.value);
                                }}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                            />
                        </div>
                        {typeTraitement != typeTraitementEnum.READ_ONLY && (!Rib || Rib == '') &&
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignSelf: 'stretch' }}>
                                <p className='downloadribtxt'>Télécharger le RIB</p>
                                <DocumentUpload
                                    required
                                    setFile={setRib}
                                    document={Rib}
                                    accept={'.png,.jpeg,.jpg,application/pdf'}
                                    setCheckUpdateValue={setCheckUpdateValue}
                                />
                            </div>
                        }
                        { (Rib && Rib != '') && //typeTraitement == typeTraitementEnum.READ_ONLY &&
                            <div style={{ alignSelf: 'stretch' }}>
                                <p className='downloadribtxt'>RIB</p>
                                <div className='frame17DocAdmini'>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            padding: '0px',
                                            alignSelf: 'stretch',
                                        }}
                                    >
                                        <div className='frame26DocAdmini'>
                                            <div className='frame19DocAdmini'>
                                                <svg
                                                    width="19"
                                                    height="25"
                                                    viewBox="0 0 19 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M17.1926 4.65625L13.677 1.14062C13.1145 0.578125 12.3645 0.25 11.5676 0.25H3.08325C1.39575 0.25 0.083252 1.60938 0.083252 3.25V21.25C0.083252 22.9375 1.39575 24.25 3.08325 24.25H15.0833C16.7239 24.25 18.0833 22.9375 18.0833 21.25V6.76562C18.0833 5.96875 17.7551 5.21875 17.1926 4.65625ZM15.8333 21.25C15.8333 21.6719 15.4583 22 15.0833 22H3.08325C2.66138 22 2.33325 21.6719 2.33325 21.25V3.29688C2.33325 2.875 2.66138 2.54688 3.08325 2.54688H10.5833V6.25C10.5833 7.09375 11.2395 7.75 12.0833 7.75H15.7864V21.25H15.8333ZM9.552 13.7031C9.552 13.5625 9.59888 13.4219 9.64575 13.2812C9.7395 13.0469 10.0208 11.8281 10.0208 10.8438C10.0208 9.95312 9.31763 9.25 8.427 9.25C7.58325 9.25 6.88013 9.95312 6.88013 10.8438C6.88013 10.8438 6.88013 12.2031 7.4895 13.75C7.16138 14.6875 6.78638 15.5781 6.31763 16.4688C5.33325 16.9375 4.4895 17.5 3.83325 18.1562C3.552 18.4844 3.41138 18.8594 3.41138 19.3281C3.41138 20.1719 4.1145 20.875 4.95825 20.875C5.47388 20.875 5.94263 20.6406 6.27075 20.2188C6.59888 19.75 7.1145 19 7.677 17.9688C8.427 17.6406 9.27075 17.4062 10.2083 17.2188C10.8176 17.6406 11.5676 18.0156 12.3645 18.25C12.552 18.3438 12.7864 18.3906 13.0208 18.3906C13.9583 18.3906 14.7083 17.6406 14.7083 16.6562C14.7083 15.7188 13.9583 14.9219 12.9739 14.9219H12.8333C12.6926 14.9219 11.8489 14.9688 10.677 15.1562C10.2083 14.7344 9.83325 14.2656 9.552 13.7031ZM5.2395 19.5156C5.052 19.75 4.677 19.6562 4.677 19.2812C4.677 19.1875 4.677 19.0938 4.72388 19.0469C5.14575 18.625 5.66138 18.25 6.22388 17.9219C5.802 18.7188 5.427 19.2344 5.2395 19.5156ZM8.427 10.5156C8.6145 10.5156 8.75513 10.6562 8.75513 10.8438C8.75513 11.5469 8.56763 12.4844 8.47388 12.8125C8.14575 11.7344 8.09888 10.9375 8.09888 10.8438C8.09888 10.6562 8.2395 10.5156 8.427 10.5156ZM7.677 16.6094C7.95825 15.9531 8.28638 15.25 8.56763 14.5C8.89575 15.0156 9.27075 15.5312 9.7395 16C9.08325 16.1406 8.38013 16.3281 7.677 16.6094ZM12.8333 16.1875H12.9739C13.2551 16.1875 13.4426 16.375 13.4426 16.7031C13.4426 16.9375 13.2551 17.125 13.0208 17.125C12.927 17.125 12.8333 17.125 12.7395 17.0781C12.177 16.8906 11.6614 16.6562 11.2395 16.375C12.177 16.2344 12.8333 16.1875 12.8333 16.1875Z"
                                                        fill="#272D3C"
                                                    />
                                                </svg>
                                            </div>
                                            {Rib?.name ?
                                                <p
                                                    className='frame20DocAdmini'
                                                    style={{textAlign:'start'}}
                                                >
                                                    {Rib?.name}
                                                </p>
                                                :
                                                <p
                                                    className='frame20DocAdmini'
                                                    style={{textAlign:'start'}}
                                                >
                                                    {SpliUrl(ribFromBackend)}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                    { //typeTraitement != typeTraitementEnum.READ_ONLY &&
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            {!Rib?.name &&
                                                <IconButton
                                                    variant='contained'
                                                    component='label'
                                                >
                                                    <a
                                                        href={API_SERVER_FILES + encodeURIComponent(ribFromBackend ?? Rib )}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        download
                                                    >
                                                        <RemoveRedEyeIcon />
                                                    </a>
                                                </IconButton>
                                            }
                                            {typeTraitement != typeTraitementEnum.READ_ONLY &&
                                            <IconButton
                                                variant='contained'
                                                component='label'
                                                onClick={() => {
                                                    setCheckUpdateValue(false);
                                                    setRib('');
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>}
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        {typeTraitement == typeTraitementEnum.READ_ONLY && (!Rib && Rib == '') &&
                            <div><Alert severity="success">Pas de Rib</Alert></div>
                        }
                    </div>
                </>
            }
            {/* //* admin could even modify tauxTva Expert */}
            {(typeTraitement == typeTraitementEnum.EXPERT_UPDATE ||
                typeTraitement == typeTraitementEnum.ADMIN_UPDATE_EXPERT ||
                typeTraitement == typeTraitementEnum.READ_ONLY) &&
                <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                    <Button
                        variant="text"
                        style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}}}
                        onClick={() => { initializeSocieteData(firstDataFromBackend?.entreprise); }}
                    >
                        {i18n.t('Annuler')}
                    </Button>
                    <Button
                        variant="contained"
                        type='submit'
                        startIcon={<SaveIcon />}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                        disabled={CheckUpdateValue}
                        style={{...buttonStylesBlue(CheckUpdateValue),...{width:device=='desktop'?'auto':'100%'}}}
                    >
                        {i18n.t('Sauvegarder')}
                    </Button>
                </div>
            }
            {/* // * completer Profile buttons */}
            {typeTraitement != typeTraitementEnum.READ_ONLY && currentPath == 'step4' &&
                <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', justifyContent: 'space-between', alignSelf: 'stretch' ,gap:device=='desktop'?'0px':'16px'}}>
                    <Button
                        variant="outlined"
                        style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}}}
                        onClick={() => navigate('/expert')}
                    >
                        {i18n.t('Remplir plus tard')}
                    </Button>
                    <Button
                        variant="contained"
                        style={{...buttonStylesBlue(),...{width:device=='desktop'?'auto':'100%'}}}
                        startIcon={<ArrowForward />}
                        type='submit'
                        ref={target}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                    >
                        {i18n.t('Valider')}
                    </Button>
                </div>
            }
            {typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT &&

                <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', justifyContent: 'flex-end', alignSelf: 'stretch' }}>
                    <Button
                        variant="contained"
                        type='submit'
                        startIcon={<ArrowForward />}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                        style={{...buttonStylesBlue(),...{width:device=='desktop'?'auto':'100%'}}}
                    >
                        {i18n.t('Valider')}
                    </Button>
                </div>
            }
        </form>
    );
}

export default SocieteGeneralisation;